import React from "react";
import {useUser} from "../contexts/AuthContext";
import AuthenticationRequired from "./Auth/AuthenticationRequired";
import Loading from "../components/Loading/Loading";

interface Props {
  component: React.FC;
}

const ProtectedRoute: React.FC<Props> = ({component}) => {
  const {user} = useUser();

  if (user) {
    if (user.isLoading) {
      return <Loading />;
    }

    if (user.authenticated) {
      return React.createElement(component);
    }
  }

  return (
    <div>
      <AuthenticationRequired />
    </div>
  );
};

export default ProtectedRoute;
